<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img :src="appLogoImage" alt="logo" />
              </span>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <!-- <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" /> -->
    <hr />
    <b-row>
      <b-col
        lg="11"
        style="padding-right: 30px"
        v-if="user.account_type == 'student' && !master"
      >
        <b-form-select
          value-field="id"
          text-field="name"
          v-model="eduProgram"
          :options="eduPrograms"
          @change="changeEduProgram"
        ></b-form-select>
      </b-col>
      <b-col
        lg="11"
        style="padding-right: 30px"
        v-else-if="
          user.account_type == 'teacher' && quran != 1
        "
      >
        <b-form-select
          value-field="id"
          text-field="name"
          v-model="eduProgram"
          :options="eduPrograms"
          @change="changeEduProgram"
        ></b-form-select>
        <b-form-select
          v-if="showRoom()"
          value-field="id"
          text-field="name"
          v-model="room"
          :options="rooms"
          @change="changeRoom"
        ></b-form-select>
      </b-col>
    </b-row>
    <hr />
    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>

    <!-- /main menu content-->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
// import {
//   admin,
//   teacher,
//   student,
//   teacherMaster,
//   studentMaster,
// } from "@/navigation/vertical";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import Auth from "@/Apis/Auth";
import vSelect from "vue-select";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    vSelect,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      eduPrograms: [],
      eduProgram: 0,
      navMenuItems: [],
      user: {},
      rooms: [],
      students: [],
      room: 0,
      student: 0,
      program: {},
      master_students: [],
      quran:0,
    };
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    return {
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,
      // Shadow Bottom
      shallShadowBottom,
      // Skin
      skin,
      // App Name
      appName,
      appLogoImage,
    };
  },
  async created() {
    this.navMenuItems = Auth.MENU_ITEMS;
    this.quran = localStorage.getItem('quran');

    this.eduPrograms = Auth.EDU_PROGRAMS;
    this.user = Auth.USER;
    this.master_students = Auth.MASTER_STUDENTS;
    this.eduProgram = localStorage.getItem("eduProgram");
    this.rooms = Auth.ROOM.filter((a) => a.edu_program_id == this.eduProgram);
    this.room = localStorage.getItem("room");
    this.master = localStorage.getItem("master");
    this.program = this.eduPrograms.find((a) => a.id == this.eduProgram);
    // if (this.user.account_type == "teacher") {
    //   let currentEduProgram = this.eduPrograms.find(
    //     (a) => a.id == this.eduProgram
    //   );
    //   let master_students_ids = this.master_students.map((el) => el.student.id);
    //    this.students = currentEduProgram.students.filter((el) =>
    //     master_students_ids.includes(el.id)
    //   );
    //    this.students.forEach((el) => {
    //     el.for_v_select = el.code + " " + el.full_name;
    //   });
    //   this.student = localStorage.getItem("student");
    // }
    // Auth.PERMISSIONS = this.navMenuItems;
  },

  methods: {
    showRoom() {
      let eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgram);
      return eduProgram.is_course != 1;
    },
    changeEduProgram() {
      localStorage.setItem("eduProgram", this.eduProgram);
      this.program = this.eduPrograms.find((a) => a.id == this.eduProgram);
      if (this.user.account_type == "teacher") {
        let eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgram);

        if (eduProgram.is_course == 1) {
          localStorage.setItem("room", eduProgram.rooms[0].id);
          // this.$router.go(this.$router.currentRoute);
          console.log("maaa");
        }
        localStorage.removeItem("student");
        this.rooms = [];
        this.rooms = Auth.ROOM.filter(
          (a) => a.edu_program_id == this.eduProgram
        );
        localStorage.remove;
      } else {
        this.$router.go(this.$router.currentRoute);
      }
    },
    changeRoom() {
      localStorage.setItem("room", this.room);
      this.$router.go(this.$router.currentRoute);
    },
    changeStudent() {
      localStorage.setItem("student", this.student);
      let eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgram);
      let student = eduProgram.students.filter((el) => el.id === this.student);
      console.log(student);
      localStorage.setItem("room", student[0].rooms[0].id);
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
